import React from 'react';
import TopNav from './TopNav';
import SideNav from './SideNav';
import Footer from './Footer';

const AppShell = ({ searchQuery, onSearchChange, children }) => {
  return (
    <div className="bg-surface text-on-surface font-body overflow-hidden min-h-screen">
      <TopNav searchQuery={searchQuery} onSearchChange={onSearchChange} />
      <SideNav />
      <main className="relative h-screen w-full pt-20 md:pl-20 overflow-hidden">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default AppShell;
